import { render, staticRenderFns } from "./DeleteScriptDialog.vue?vue&type=template&id=adfc750a&scoped=true"
import script from "./DeleteScriptDialog.vue?vue&type=script&lang=js"
export * from "./DeleteScriptDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteScriptDialog.vue?vue&type=style&index=0&id=adfc750a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfc750a",
  null
  
)

export default component.exports